import { render, staticRenderFns } from "./HeaderSingleAssistance.vue?vue&type=template&id=6d456b7d&"
import script from "./HeaderSingleAssistance.vue?vue&type=script&lang=js&"
export * from "./HeaderSingleAssistance.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSingleAssistance.vue?vue&type=style&index=0&id=6d456b7d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports